module.exports = __webpack_public_path__ + "static/img/way_one_main.7c61605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/products/way_one_main.png
// module id = BvQG
// module chunks = 1